import { useEffect, useRef, useState } from "react";

const useZoom = (): number => {
  const [zoom, setZoom] = useState<number>(1);

  const touchDistanceRef = useRef<number>(0);

  const touchStartHandler = (e: TouchEvent) => {
    if (e.touches.length !== 2) return;
    const s = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
    touchDistanceRef.current = s;
  }

  const touchMoveHandler = (e: TouchEvent) => {
    if (e.touches.length !== 2) return;
    const s = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
    const diff = s - touchDistanceRef.current;
    if (diff > 0.5) { // zoom in
      setZoom((z) => Math.min(Math.max(z + 0.1, 1), 5));
    } else if (diff < -0.5) { // zoom out
      setZoom((z) => Math.max(z - 0.1, 1));
    }
    touchDistanceRef.current = s;
  }

  const touchEndHandler = () => {
    touchDistanceRef.current = 0;
  }

  const removeEventListeners = () => {
    window.removeEventListener("touchstart", touchStartHandler);
    window.removeEventListener("touchmove", touchMoveHandler);
    window.removeEventListener("touchend", touchEndHandler);
  }

  useEffect(() => {
    window.addEventListener("touchstart", touchStartHandler, false);
    window.addEventListener("touchmove", touchMoveHandler, false);
    window.addEventListener("touchend", touchEndHandler, false);
    return () => {
      removeEventListeners();
    };
  }, []);

  return zoom;
};

export default useZoom;
